export default __webpack_public_path__ + "static/Artificial_Light_Indoor_320kbps-1b748060c12676048f4ed55b3cf26c58.avif";